import { Button, Container, Grid, Paper, Typography } from "@material-ui/core";
import React from "react";
import { H1, H2 } from "../Headers";
import ImgHeader from "../ImgHeader";
import styled from "styled-components";
import { RouteComponentProps, withRouter } from "react-router";

const SuccessContainer = styled(Container)`
  margin: auto;
`;

const SuccessPaper = styled(Paper)`
  max-width: 100%;
  margin: 3em 0;
  padding: 2em;
  text-align: center;
`;

const SuccessParagraph = styled(Typography)`
  margin: 5px;
  padding: 5px;
  overflow-wrap: break-word;
`;

const CopyButton = styled(Button)`
  margin: 5px;
  padding: 5px;
  background-color: lightgray;
`;

const copyCurlText = (text: string) => {
  navigator.clipboard.writeText(text);
};

const APICredentialsSuccess = (props: RouteComponentProps) => {
  let sc = props.location.state;
  if (!sc || !sc.CurlText) {
    props.history.push("/");
    return null;
  }
  return (
    <>
      <ImgHeader url="/static/img/kelly-sikkema-fvpgfw3IF1w-unsplash.jpg" shadowOpacity={0.4}>
        <H1>Your SMS Request was successful!</H1>
      </ImgHeader>
      <SuccessContainer>
        <Grid item spacing={3}>
          <SuccessPaper>
            <H2>The SMS credentials you supplied were valid.</H2>
            <SuccessParagraph paragraph>
              You can run the following command from your server's command line to test if you are having a firewall issue:
            </SuccessParagraph>
            <SuccessParagraph paragraph variant="body2">
              {sc.CurlText}
            </SuccessParagraph>
            <CopyButton onClick={() => copyCurlText(sc.CurlText)}>Copy to Clipboard</CopyButton>
            <SuccessParagraph>Please note that this command text will need to be renewed after some time.</SuccessParagraph>
          </SuccessPaper>
        </Grid>
      </SuccessContainer>
    </>
  );
};

export default withRouter(APICredentialsSuccess);
